import PrintingContainer from "../../../Component/Application/PrintingSection/printing-container";

const PrintingPage = () => {
    return (
        <div className="page-body">
            <PrintingContainer />
            </div>
    );
};

export default PrintingPage